import React from "react";
import * as CONSTANT from "../../constants";
import NewFooter from "../Footer/NewFooter";
import { ArrowImage, ArrowMobImage } from "../../images/svgIcons/svg";
import styles from "./maintenancePage.module.scss";
import StrawberryImage from "../../../src/images/desktopStrawberry.png";
import MobStrawberryImage from "../../../src/images/mobStrawberry.png";

const MaintenancePage = () => {
  const handleTryAgain = (event: React.MouseEvent<HTMLAnchorElement>) => {
    event.preventDefault();
    window.location.reload();
  };

  return (
    <>
      <div className="container py-5">
        <div className={`${styles.strawberrySection}`}>
          <div className="d-flex justify-content-center align-items-center">
            <img
              src={StrawberryImage}
              alt="Strawberry Image"
              className="d-md-block d-none"
            />
            <img
              src={MobStrawberryImage}
              alt="Strawberry Image"
              className="d-md-none d-block"
            />
          </div>
        </div>
        <div className="mb-5">
          <h1 className="font-Cls f-s45 f-sm-s16 f-w4 clr-dark-blue ls-normal mb-3">
            We&apos;re Under Maintenance.
          </h1>
          <div className="d-flex justify-content-center gap-4 pb-md-4">
            <p className="font-Trade-regular f-w4 f-s24 f-sm-s14">
              Our site is temporarily unavailable. Please check back shortly.
            </p>
            <div className="mt-3 d-md-block d-none">
              <ArrowImage />
            </div>
            <div className="mt-3 d-md-none d-block">
              <ArrowMobImage />
            </div>
          </div>
          <div className={`${styles.ordersBtn}`}>
            <a
              href="#"
              onClick={handleTryAgain}
              className="btn btn-large text-uppercase font-Visby-cf f-s20 f-sm-s14 f-w7 mx-3 py-2 my-2 px-4"
            >
              try again
            </a>
            <a
              href={CONSTANT.ROUTE_HOME}
              className="btn btn-large font-Visby-cf f-s20 f-sm-s14 f-w7 text-uppercase mx-3 py-2 my-2 px-4"
            >
              return home
            </a>
          </div>
        </div>
      </div>
      <NewFooter />
    </>
  );
};

export default MaintenancePage;
